// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"754":"7ff28830","835":"be31655a"}[chunkId] + ".chunk.css");